import "./DialPad.css"
import Div from "../base/Div";
import FlexRow from "../base/FlexRow";
import Icon from "../base/Icon";
import { useEffect, useRef, useState } from "react";
import { CallStateSnapshot, SipPhoneManager } from "../../core/SipPhoneManager";


interface IProps {
    call: CallStateSnapshot
    phone: SipPhoneManager
}
export default function InCallDialPad(props: IProps) {

    const inputRef = useRef<HTMLInputElement>(null)
    const [value, setValue] = useState("")


    useEffect(() => {
        inputRef.current?.focus()
    }, [value])


    return (
        <FlexRow className="mx-10 mb-10" column>
            <input type="text" className="dialpad-text"
                ref={inputRef} autoFocus
                value={value} readOnly disabled />

            <FlexRow className="w-100" justify="center">
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "1")
                        await props.phone.sendDtmf(props.call.id, "1")
                    }}>
                    1
                </Div>
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "2")
                        await props.phone.sendDtmf(props.call.id, "2")
                    }}>
                    2
                </Div>
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "3")
                        await props.phone.sendDtmf(props.call.id, "3")
                    }}>
                    3
                </Div>
            </FlexRow>

            <FlexRow className="w-100" justify="center">
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "4")
                        await props.phone.sendDtmf(props.call.id, "4")
                    }}>
                    4
                </Div>
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "5")
                        await props.phone.sendDtmf(props.call.id, "5")
                    }}>
                    5
                </Div>
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "6")
                        await props.phone.sendDtmf(props.call.id, "6")
                    }}>
                    6
                </Div>
            </FlexRow>

            <FlexRow className="w-100" justify="center">
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "7")
                        await props.phone.sendDtmf(props.call.id, "7")
                    }}>
                    7
                </Div>
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "8")
                        await props.phone.sendDtmf(props.call.id, "8")
                    }}>
                    8
                </Div>
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "9")
                        await props.phone.sendDtmf(props.call.id, "9")
                    }}>
                    9
                </Div>
            </FlexRow>

            <FlexRow className="w-100" justify="center">
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "*")
                        await props.phone.sendDtmf(props.call.id, "*")
                    }}>
                    *
                </Div>
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "0")
                        await props.phone.sendDtmf(props.call.id, "0")
                    }}>
                    0
                </Div>
                <Div className="dialpad-number"
                    onClick={async e => {
                        setValue(value + "#")
                        await props.phone.sendDtmf(props.call.id, "#")
                    }}>
                    #
                </Div>
            </FlexRow>

        </FlexRow>
    )
}